let conf = [
  {
    text: 'Strona redakcyjna',
    items: [
      { text: 'Kierownik projektu <br/><i>Ewelina Włodarczyk</i>' },
      { text: 'Kierownik projektu <br/><i>Ewelina Włodarczyk</i>' },
      { text: 'Kierownik projektu <br/><i>Ewelina Włodarczyk</i>' },
      { text: 'Kierownik projektu <br/><i>Ewelina Włodarczyk</i>' },
      { text: 'Kierownik projektu <br/><i>Ewelina Włodarczyk</i>' },
    ],
  },
  {
    text: 'Wykaz praw autorskich w multibooku',
    search: true,
    items: [
      {
        id: 'ID0001',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0002',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0003',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0004',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0005',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0006',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0007',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0008',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0009',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0010',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0011',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0012',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0013',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0014',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0015',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0016',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0017',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0018',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0019',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0020',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0021',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0022',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0023',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0024',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
      {
        id: 'ID0025',
        text: '<b>Shutterstock.com:</b> duosagbdas kbdhasbd ikwevd wiydvwqidv wqkjx 7e 213fe3idvqikdgty238d f2v3iodyv2q3yior 32fd 2378dfvt3e78r923fd 32vdiykqwed 6g2397d f38dcviywe',
      },
    ],
  },
];
export default conf;
